import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../common/commonIndex";
import { Image, DoctorDetails } from "../../components/componentIndex";
import MarkLocationIcon from '../../assets/images/doctorProfile/map-marker.svg';
import DateIcon from '../../assets/images/doctorProfile/calender-icon.svg';
import AlertCircleIcon from '../../assets/images/doctorProfile/alert-circle.svg';
import DatePicker from "react-datepicker";
import DoctorProfile from '../../assets/images/dashboard/profile-1.svg';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import { toast } from "react-toastify";
import PatientService from 'services/API/patientService';
import BackIcon from '../../assets/images/doctorProfile/right-arrow.svg';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { doctorProfileRequestState } from '../../services/data.searvice';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import LeftChevron from '../../assets/images/left-chevron.svg';

const ConfirmRequest = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [calenderValue, setCalenderValue] = useState('');
    const [colonosCopy, setColonosCopy] = useState(true);
    const [endosCopy, setEndosCopy] = useState(false);
    const [doctorProfileRequest, setDoctorProfileRequest] = useRecoilState(doctorProfileRequestState);
    const { state: data } = useAuthenticationContext();
    const [currentUserInfo, setCurrentUserInfo] = useState(data?.userData?.result);
    const hasRun = useRef(false);
    const [searchParams] = useSearchParams();


    useEffect(() => {
        setCurrentUserInfo(data?.userData?.result);
        if (!doctorProfileRequest?.selectedDate) {
            if (!hasRun.current) {
                hasRun.current = true;
                window.history.back();
            }
        } else {
            setCalenderValue(doctorProfileRequest?.selectedDate);
        }
    }, [])

    const doctorInfo = {
        name: doctorProfileRequest?.doctorData?.firstName + ' ' + doctorProfileRequest?.doctorData?.lastName + ', ' + doctorProfileRequest?.doctorData?.credential,  //'Jessica Johnson, MD',
        firstName: doctorProfileRequest?.doctorData?.firstName,  //'Jessica Johnson, MD',
        lastName: doctorProfileRequest?.doctorData?.lastName,  //'Jessica Johnson, MD',
        specialization: doctorProfileRequest?.doctorData?.specialtyName, //'Gastroenterology',
        organizationName: doctorProfileRequest?.doctorData?.organizationName, //'Gastroenterology',
        address: doctorProfileRequest?.doctorData?.address, //'Novant Medical Center',
        practiceName: doctorProfileRequest?.doctorData?.surgeryCenter, //'Novant Medical Center',
        rating: doctorProfileRequest?.reviewList,
        photo: doctorProfileRequest?.doctorData?.profileSignedUrl // DoctorProfile
    }
    const today = new Date();
    // Get the last day of the current month
    const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const calenderOnChange = (date) => {
        setCalenderValue(date);
        closeFullScreen();
    };

    // Function to add custom class to disabled days
    const dayClassName = (date) => {
        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();

        // Add class if date is before today and it's not today itself
        if (date < today && !isToday) {
            return 'disabled-before-today'; // Class for days before today
        }

        // Add class if date is after the last day of the current month
        if (date > endOfCurrentMonth) {
            return 'disabled-after-current-month'; // Class for days after current month
        }

        return ''; // No class for valid days and today itself
    };

    const handleColonosCopy = (e) => {
        e.preventDefault();
        setColonosCopy(!colonosCopy);
        setEndosCopy(!endosCopy);
    }
    const handleConfirmRequest = (e) => {
        e.preventDefault();

        confirmRequest();
    }

    const confirmRequest = async () => {
        try {
            const date = new Date(doctorProfileRequest?.selectedDate);

            // Extract only the date in YYYY-MM-DD format
            const formattedDate = date.toISOString().slice(0, 10);
            let requestObject = {
                fkProviderId: doctorProfileRequest?.doctorData?.fkUserId,
                appointmentDate: formattedDate,
                startTime: doctorProfileRequest?.times?.startTime,
                endTime: doctorProfileRequest?.times?.endTime,
                roomId: doctorProfileRequest?.times?.roomId //2147483647
            }

            const accessToken = data?.userData?.result?.token;
            if (accessToken) {
                const response = await PatientService.bookVisit(requestObject, accessToken);
                if (response?.statusCode === 200) {
                    // navigate('/questionnaire');
                    localStorage.removeItem('listOfAnswer');
                    navigate('/questionnaire?fkUserId=' + doctorProfileRequest?.doctorData?.fkUserId + '&appointmentId=' + response?.result?.appointmentId + '&step=0');
                }
                return response;
            } else {
                // navigate('/questionnaire');
                navigate('/questionnaire?fkUserId=' + doctorProfileRequest?.doctorData?.fkUserId);
            }

        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    const extractAddress = (address) => {
        if (!address) {
            return;
        }
        const addressParts = address?.split(','); // Split by commas
        const street = addressParts[0]?.trim(); // Street Address
        const city = addressParts[1]?.trim(); // City
        const state = addressParts[2]?.split('(')[0]?.trim(); // State (remove ZIP code in parentheses)

        return `${street}, ${city}, ${state}`;
    };
    const handleEndosCopy = (e) => {
        e.preventDefault();
        setEndosCopy(!endosCopy);
        setColonosCopy(!colonosCopy);
    }


    const [isFullScreen, setIsFullScreen] = useState(false);


    const closeFullScreen = () => {
        setIsFullScreen(false);
    };

    const handleLogin = () => {
        navigate('/questionnaire');
    }
    const handleBackScreen = () => {
        window.history.back();
    }


    const formatLocation = (loc) => {
        return loc?.replace(/(\d{5})/, '\n$1');
    }

    return (
        <div className="custom-container doctor-profile-content">
            <div className="profile-card confirm-request">
                <div className="profile-info ">
                    <div className="d-flex align-items-center">
                        {/* <div className="circle-btn back-to-prev-screen confirm-back me-3" onClick={handleBackScreen}>
                            <Image imgUrl={BackIcon} altText={''} className={''} />
                        </div> */}
                        <div onClick={handleBackScreen} className='cursor-pointer confirm-req-back'>
                            <Image imgUrl={LeftChevron} altText={'Left Chevron'} />
                        </div>
                        <h3 className="title">Confirm request</h3>
                    </div>
                    <div>
                        <DoctorDetails doctorInformation={doctorInfo} isConfirmRequest={true} />
                    </div>
                    <div className="divider my-3"></div>
                    <div className="booking-details">
                        <div className="booking">
                            <h3 className="booking-title mb-3">Booking details</h3>
                            <ul>
                                <li> <Image imgUrl={MarkLocationIcon} altText={'modem'} className={'modem'} />
                                    <div className="">
                                        <p className="title">Location</p>
                                        <div>
                                            <p className="description address mb-0">
                                                {doctorProfileRequest?.doctorData?.surgeryCenter}
                                            </p>
                                        </div>
                                        <div>
                                            <p className="description address">
                                                {formatLocation(doctorProfileRequest?.doctorData?.surgeryCenterAddress)}
                                                {/* {extractAddress(doctorProfileRequest?.doctorData?.surgeryCenterAddress)} */}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li> <Image imgUrl={DateIcon} altText={'monitor'} className={'monitor'} />

                                    <div className="">
                                        <p className="title">Date</p>
                                        <p className="description">
                                            {(calenderValue || today).toLocaleString('en-US', {
                                                weekday: 'short',   // 'Tue'
                                                month: 'long',      // 'March'
                                                day: 'numeric',     // '11'
                                                // hour: 'numeric',    // '7'
                                                // minute: 'numeric',  // '30'
                                                // hour12: true        // 'AM/PM' format
                                            })} {doctorProfileRequest?.times?.startTime ? 'at ' + doctorProfileRequest?.times?.startTime : ''}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <div className="divider my-3"></div>
                            {data?.userData?.result && data?.userData?.result?.token ? (
                                <>
                                    <div className="d-flex align-items-start">
                                        <Image imgUrl={AlertCircleIcon} altText={'medicalCase'} className={'medical-case'} />
                                        <div>
                                            <p className="alert">
                                                Before we can schedule your appointment, we will need information about your health to confirm your eligibility for open access colonoscopy. Please fill out the following questionnaire. We will hod your requested appointment date and time for 24 hours.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="destop-tablet-screen">
                                        <div className="d-flex align-items-start">
                                            <Button btnClass={'btn-primary request-btn'}
                                                btnName={'Continue'}
                                                btnType={'button'}
                                                onClick={handleConfirmRequest}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="destop-tablet-screen">
                                        <div className="d-flex align-items-start">
                                            <Button btnClass={'btn-primary request-btn login-in-request-btn'}
                                                btnName={'Log in or sign up to Continue'}
                                                btnType={'button'}
                                                onClick={handleLogin}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    </div>
                </div>
                <div className="mt-5 mt-md-0">
                    <div className="mobile-screen">
                        <div className="d-flex justify-content-center align-items-center w-300">
                            {currentUserInfo && currentUserInfo?.token ? (
                                <Button btnClass={'btn-primary request-btn'}
                                    btnName={'Continue'}
                                    btnType={'button'}
                                    onClick={handleConfirmRequest}
                                    isDisabled={true}
                                />
                            ) : (
                                <Button btnClass={'btn-primary request-btn'}
                                    btnName={'Log in or sign up to Continue'}
                                    // btnName={'Log in to Continue'}
                                    btnType={'button'}
                                    onClick={handleLogin}
                                    isDisabled={true}
                                />
                            )}

                        </div>
                    </div>

                    {/* Full-screen DatePicker */}

                    <div className="destop-tablet-screen">
                        <div className="doctor-profile-datepicker-box">
                            <div className="justify-content-center mb-5">

                                <Button btnClass={`colonos-copy-btn me-2 ${colonosCopy ? 'btn-primary' : 'button-secondary ms-2'}`}
                                    btnName={'Colonoscopy'}
                                    btnType={'button'}
                                    onClick={handleColonosCopy}
                                    isDisabled={true}
                                />
                                {/* <Button btnClass={`colonos-copy-btn me-2 ${endosCopy ? 'btn-primary' : 'button-secondary ms-2'}`}
                                    btnName={'Endoscopy'}
                                    btnType={'button'}
                                    onClick={handleEndosCopy}
                                    isDisabled={true}

                                /> */}
                            </div>
                            <div className="calendar-container margin-y-50">
                                <DatePicker
                                    // onChange={(date) => calenderOnChange(date)}
                                    selected={calenderValue}
                                    inline
                                    dayClassName={dayClassName} //
                                    calendarStartDay={0}
                                    locale="it"
                                    minDate={new Date(calenderValue)} // Disable dates before today
                                    maxDate={new Date(calenderValue)} // Disable dates after Dec 31, 2024
                                />
                            </div>

                            <div className="">
                                <div className="selected-datetime-content mx-auto">
                                    <p className="mb-0 selected-datetime">
                                        {(calenderValue || today).toLocaleString('en-US', {
                                            weekday: 'short',   // 'Tue'
                                            month: 'long',      // 'March'
                                            day: 'numeric',     // '11'

                                        })} {doctorProfileRequest?.times?.startTime ? 'at ' + doctorProfileRequest?.times?.startTime : ''}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isFullScreen && (
                <div className="calendar-fullscreen-overlay">
                    <div className="calendar-fullscreen-content">
                        <button className="close-button circle-btn" onClick={closeFullScreen}>
                            <Image imgUrl={CloseIcon} altText={'close'} className={''} />
                        </button>
                        <h2 className="calendar-title">Choose a day and time</h2>
                        <div>
                            <DatePicker
                                // onChange={(date) => calenderOnChange(date)}
                                selected={calenderValue}
                                inline
                                dayClassName={dayClassName}
                                calendarStartDay={0}
                                locale="it"
                                minDate={new Date(calenderValue)} // Disable dates before today
                                maxDate={new Date(calenderValue)} // Disable dates after Dec 31, 2024
                            />
                        </div>

                    </div>
                </div>
            )}
        </div>


    );
};

export default ConfirmRequest;